// extracted by mini-css-extract-plugin
export default {"idLogin":"index_idLogin__SrXqn","forget":"index_forget__Htnjo","formItem":"index_formItem__10kGf","tips":"index_tips__6B2Jz"};